export default function euroFormate(e) {
    let montant = '';
    if (e !== null) {
        montant = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(e);
        return montant;
    }
}
